import { encodeToBase64 } from '@modules/common/utils';
import {
  IntegrationChannelType,
  IntegrationDirection,
  IntegrationType,
} from 'generated/graphql';

export interface EncodeOAuthStateParams {
  channelType: IntegrationChannelType;
  direction: IntegrationDirection;
  data: { [key: string]: string | number | boolean | undefined };
  integrationType: IntegrationType;
  integrationID?: string;
}

export const encodeOAuthState = ({
  channelType,
  direction,
  data,
  integrationType,
  integrationID,
}: EncodeOAuthStateParams) => {
  const JSONToEncode = JSON.stringify({
    channelType,
    direction,
    data,
    integrationType,
    integrationID,
  });
  return encodeToBase64(JSONToEncode);
};
